





















// 'use client';

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { CheckCircle, AlertCircle, Loader2, ArrowRight } from 'lucide-react';

// const ProfileCompletionTracker = () => {
//   const [completionData, setCompletionData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const token = localStorage.getItem('token');

//   useEffect(() => {
//     const fetchProfileCompletion = async () => {
//       if (!token) {
//         setError("No authentication token found. Please login again.");
//         setLoading(false);
//         return;
//       }

//       try {
//         const response = await axios.get(
//      `${process.env.REACT_APP_API_URL}jobseeker/profile-completion`,

//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );

//         setCompletionData(response.data.data);
//       } catch (err) {
//         console.error(err);
//         setError(err.response?.data?.message || "Failed to load profile completion");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProfileCompletion();
//   }, [token]);

//   if (loading) {
//     return (
//       <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-8 flex items-center justify-center h-52">
//         <div className="flex items-center gap-4">
//           <Loader2 className="w-8 h-8 animate-spin text-orange-500" />
//           <p className="text-gray-600 dark:text-gray-400">Calculating profile progress...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-800 rounded-3xl p-8 text-center">
//         <AlertCircle className="w-12 h-12 text-red-500 mx-auto" />
//         <p className="mt-4 text-red-600 dark:text-red-400">{error}</p>
//       </div>
//     );
//   }

//   const { completionPercentage, filledCount, totalFields, missingFields } = completionData || {};
//   const isComplete = completionPercentage === 100;

//   // Circle settings
//   const radius = 65;
//   const circumference = 2 * Math.PI * radius;
//   const strokeDashoffset = circumference - (completionPercentage / 100) * circumference;

//   return (
//     <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-8 border border-gray-100 dark:border-gray-700">
//       <div className="flex flex-col lg:flex-row items-center gap-10">

//         {/* Left Side - Circular Progress + Percentage */}
//         <div className="flex-shrink-0 flex flex-col items-center">
//           <div className="relative">
//             <svg className="w-48 h-48 -rotate-90" viewBox="0 0 200 200">
//               {/* Background Circle */}
//               <circle
//                 cx="100"
//                 cy="100"
//                 r={radius}
//                 fill="none"
//                 stroke="#e5e7eb"
//                 strokeWidth="16"
//               />
//               {/* Progress Circle */}
//               <circle
//                 cx="100"
//                 cy="100"
//                 r={radius}
//                 fill="none"
//                 stroke={isComplete ? "#22c55e" : "#f97316"}
//                 strokeWidth="16"
//                 strokeDasharray={circumference}
//                 strokeDashoffset={strokeDashoffset}
//                 strokeLinecap="round"
//                 className="transition-all duration-1000 ease-out"
//               />
//             </svg>

//             {/* Center Content */}
//             <div className="absolute inset-0 flex flex-col items-center justify-center">
//               <div className="text-6xl font-bold text-gray-900 dark:text-white tracking-tighter">
//                 {completionPercentage}
//                 <span className="text-4xl font-medium">%</span>
//               </div>
//               <p className="text-sm text-gray-500 dark:text-gray-400 -mt-1">Complete</p>
//             </div>
//           </div>

//           {/* Filled Count */}
//           <div className="mt-4 text-center">
//             <p className="text-lg font-semibold text-gray-700 dark:text-gray-300">
//               {filledCount} / {totalFields}
//             </p>
//             <p className="text-xs text-gray-500">fields filled</p>
//           </div>
//         </div>

//         {/* Right Side - Content */}
//         <div className="flex-1 space-y-6">

//           {/* Header */}
//           <div>
//             <h2 className="text-3xl font-semibold text-gray-800 dark:text-white">
//               Profile Completion
//             </h2>
//             <p className="text-gray-500 dark:text-gray-400 mt-1">
//               The more complete your profile, the higher your chances of getting hired
//             </p>
//           </div>

//           {/* Linear Progress Bar */}
//           <div>
//             <div className="flex justify-between text-sm mb-2">
//               <span className="font-medium text-gray-700 dark:text-gray-300">Progress</span>
//               <span className={`font-semibold ${isComplete ? 'text-green-600' : 'text-orange-600'}`}>
//                 {completionPercentage}%
//               </span>
//             </div>
//             <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-2xl overflow-hidden">
//               <div
//                 className={`h-full rounded-2xl transition-all duration-1000 ${
//                   isComplete ? 'bg-green-500' : 'bg-[#F97316]'
//                 }`}
//                 style={{ width: `${completionPercentage}%` }}
//               />
//             </div>
//           </div>

//           {/* Status Message */}
//           <div className={`p-5 rounded-2xl flex items-start gap-4 ${
//             isComplete 
//               ? 'bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800' 
//               : 'bg-orange-50 dark:bg-orange-950 border border-orange-200 dark:border-orange-800'
//           }`}>
//             {isComplete ? (
//               <>
//                 <CheckCircle className="w-7 h-7 text-green-600 mt-0.5" />
//                 <div>
//                   <p className="font-semibold text-green-700 dark:text-green-400">
//                     Excellent! Your profile is fully complete.
//                   </p>
//                   <p className="text-sm text-green-600 dark:text-green-500 mt-1">
//                     You're ready to receive the best job opportunities.
//                   </p>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <AlertCircle className="w-7 h-7 text-orange-600 mt-0.5" />
//                 <div>
//                   <p className="font-semibold text-orange-700 dark:text-orange-400">
//                     You're {100 - completionPercentage}% away from a complete profile
//                   </p>
//                   <p className="text-sm text-orange-600 dark:text-orange-500 mt-1">
//                     Complete the missing fields to boost your visibility.
//                   </p>
//                 </div>
//               </>
//             )}
//           </div>

//           {/* Missing Fields */}
//           {!isComplete && missingFields && missingFields.length > 0 && (
//             <div>
//               <div className="flex items-center justify-between mb-3">
//                 <h3 className="font-medium text-gray-700 dark:text-gray-300 flex items-center gap-2">
//                   <AlertCircle className="w-5 h-5 text-orange-500" />
//                   Missing Information
//                 </h3>
//                 <span className="text-xs text-gray-500">{missingFields.length} fields</span>
//               </div>

//               <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-h-56 overflow-y-auto pr-2">
//                 {missingFields.slice(0, 10).map((field, index) => (
//                   <div
//                     key={index}
//                     className="flex items-center gap-3 bg-gray-50 dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all px-4 py-3 rounded-2xl text-sm group"
//                   >
//                     <div className="w-2.5 h-2.5 bg-orange-500 rounded-full flex-shrink-0" />
//                     <span className="capitalize text-gray-700 dark:text-gray-300 group-hover:text-orange-600 transition">
//                       {field.replace(/([A-Z])/g, ' $1').trim()}
//                     </span>
//                   </div>
//                 ))}
//               </div>

//               {missingFields.length > 10 && (
//                 <p className="text-xs text-gray-400 text-center mt-3">
//                   +{missingFields.length - 10} more fields to complete
//                 </p>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfileCompletionTracker;

'use client';

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react';

const ProfileCompletionTracker = () => {
  const [completionData, setCompletionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchProfileCompletion = async () => {
      if (!token) {
        setError("No authentication token found. Please login again.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}jobseeker/profile-completion`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setCompletionData(response.data.data);
      } catch (err) {
        console.error(err);
        setError(err.response?.data?.message || "Failed to load profile completion");
      } finally {
        setLoading(false);
      }
    };

    fetchProfileCompletion();
  }, [token]);

  if (loading) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-6 sm:p-8 flex items-center justify-center min-h-[280px]">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-9 h-9 animate-spin text-orange-500" />
          <p className="text-gray-600 dark:text-gray-400 text-center">
            Calculating profile progress...
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 dark:bg-red-950 border border-red-200 dark:border-red-800 rounded-3xl p-8 text-center">
        <AlertCircle className="w-12 h-12 text-red-500 mx-auto" />
        <p className="mt-4 text-red-600 dark:text-red-400">{error}</p>
      </div>
    );
  }

  const { completionPercentage, filledCount, totalFields, missingFields } = completionData || {};
  const isComplete = completionPercentage === 100;

  const radius = 62;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (completionPercentage / 100) * circumference;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-3xl shadow-lg p-5 sm:p-8 border border-gray-100 dark:border-gray-700 overflow-hidden">
      
      {/* Main Container - Mobile First */}
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

        {/* Circular Progress Section */}
        <div className="flex-shrink-0 flex flex-col items-center mx-auto lg:mx-0">
          <div className="relative w-[200px] h-[200px] sm:w-[220px] sm:h-[220px]">
            <svg 
              className="w-full h-full -rotate-90" 
              viewBox="0 0 200 200"
            >
              {/* Background Circle */}
              <circle
                cx="100"
                cy="100"
                r="65"
                fill="none"
                stroke="#e5e7eb"
                strokeWidth="14"
              />
              {/* Progress Circle */}
              <circle
                cx="100"
                cy="100"
                r="65"
                fill="none"
                stroke={isComplete ? "#22c55e" : "#f97316"}
                strokeWidth="14"
                strokeDasharray="408.4"
                strokeDashoffset={circumference - (completionPercentage / 100) * circumference}
                strokeLinecap="round"
                className="transition-all duration-1000 ease-out"
              />
            </svg>

            {/* Center Percentage */}
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="text-6xl font-bold text-gray-900 dark:text-white tracking-tighter">
                {completionPercentage}
                <span className="text-4xl font-medium">%</span>
              </div>
              <p className="text-sm text-gray-500 dark:text-gray-400 -mt-1">Complete</p>
            </div>
          </div>

          {/* Filled Count */}
          <div className="mt-6 text-center">
            <p className="text-2xl font-semibold text-gray-700 dark:text-gray-300">
              {filledCount} / {totalFields}
            </p>
            <p className="text-xs text-gray-500">fields filled</p>
          </div>
        </div>

        {/* Content Section */}
        <div className="flex-1 w-full space-y-6 pt-2 lg:pt-0">

          {/* Header */}
          <div className="text-center lg:text-left">
            <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 dark:text-white">
              Profile Completion
            </h2>
            <p className="text-gray-500 dark:text-gray-400 mt-2 text-sm sm:text-base max-w-md mx-auto lg:mx-0">
              The more complete your profile, the higher your chances of getting hired
            </p>
          </div>

          {/* Linear Progress Bar */}
          <div>
            <div className="flex justify-between text-sm mb-2">
              <span className="font-medium text-gray-700 dark:text-gray-300">Progress</span>
              <span className={`font-semibold ${isComplete ? 'text-green-600' : 'text-orange-600'}`}>
                {completionPercentage}%
              </span>
            </div>
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full transition-all duration-1000 ${
                  isComplete ? 'bg-green-500' : 'bg-orange-500'
                }`}
                style={{ width: `${completionPercentage}%` }}
              />
            </div>
          </div>

          {/* Status Message */}
          <div className={`p-5 rounded-2xl flex items-start gap-4 ${
            isComplete 
              ? 'bg-green-50 dark:bg-green-950 border border-green-200 dark:border-green-800' 
              : 'bg-orange-50 dark:bg-orange-950 border border-orange-200 dark:border-orange-800'
          }`}>
            {isComplete ? (
              <>
                <CheckCircle className="w-7 h-7 text-green-600 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-green-700 dark:text-green-400">
                    Excellent! Your profile is fully complete.
                  </p>
                  <p className="text-sm text-green-600 dark:text-green-500 mt-1">
                    You're ready to receive the best job opportunities.
                  </p>
                </div>
              </>
            ) : (
              <>
                <AlertCircle className="w-7 h-7 text-orange-600 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-orange-700 dark:text-orange-400">
                    You're {100 - completionPercentage}% away from a complete profile
                  </p>
                  <p className="text-sm text-orange-600 dark:text-orange-500 mt-1">
                    Complete the missing fields to boost your visibility.
                  </p>
                </div>
              </>
            )}
          </div>

          {/* Missing Fields */}
          {!isComplete && missingFields?.length > 0 && (
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-medium text-gray-700 dark:text-gray-300 flex items-center gap-2">
                  <AlertCircle className="w-5 h-5 text-orange-500" />
                  Missing Information
                </h3>
                <span className="text-xs bg-orange-100 dark:bg-orange-900 text-orange-600 px-3 py-1 rounded-full">
                  {missingFields.length} fields
                </span>
              </div>

              <div className="space-y-3 max-h-[260px] overflow-y-auto pr-2">
                {missingFields.slice(0, 12).map((field, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 bg-gray-50 dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 px-4 py-4 rounded-2xl text-sm transition-colors"
                  >
                    <div className="w-2.5 h-2.5 bg-orange-500 rounded-full flex-shrink-0" />
                    <span className="capitalize text-gray-700 dark:text-gray-300">
                      {field.replace(/([A-Z])/g, ' $1').trim()}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionTracker;